import Immutable from 'immutable';
import urlResolver from 'edrolo/utils/URLResolver';
import { createSelector } from 'reselect';
import { calculateStudentLessonProgressSummary } from '../../utils';

export const getClassLessonGridData = createSelector(
  [
    (state, ownProps) => ownProps.enrolmentProfiles,
    (state, ownProps) => ownProps.classLessonProgress,
    (state, ownProps) => ownProps.classStudentLessonProgress,
  ],
  (enrolmentProfiles, classLessonProgress, classStudentLessonProgress) => {
    return (
      enrolmentProfiles &&
      enrolmentProfiles.reduce((acc, profile) => {
        const profileId = profile.get('id').toString();
        const studentLessonProgress =
          classStudentLessonProgress &&
          classStudentLessonProgress.get(profileId);
        const studentProgressSummary = calculateStudentLessonProgressSummary(
          profileId,
          classLessonProgress,
          studentLessonProgress
        );

        // start with the profile, lesson progress
        const profileRow = Immutable.fromJS({
          profile,
          progress: studentLessonProgress,
          summary: studentProgressSummary,
        });

        return acc.push(profileRow);
      }, Immutable.List())
    );
  }
);

export const getBreadcrumbs = createSelector(
  [(state, ownProps) => ownProps.lesson, (state, ownProps) => ownProps.classId],
  (lesson, classId) => {
    const courseTitle = lesson && lesson.get('course_title');
    const coursePageUrl = urlResolver.reverse('course-page', {
      classId,
    });
    const mySubjectsUrl = urlResolver.getPath('courses-page');
    const topicTitle = lesson?.get('topic_title');
    const topicPageUrl = urlResolver.reverse('topic-page', {
      classId,
      topicId: lesson?.get('parent'),
    });

    return [
      { label: 'My subjects', url: mySubjectsUrl, anchor: true },
      { label: courseTitle, url: coursePageUrl },
      {
        label: topicTitle,
        url: topicPageUrl,
      },
      {
        label: lesson?.get('title'),
        url: topicPageUrl + `#${lesson?.get('id')}`,
      },
    ];
  }
);
